import Model from './Model'

export default class GlobalSpec extends Model
{
    static parseAttributes(attributes = {}) {
        attributes.materials = _.filter(attributes.materials, function (materialLine) {
            return ! (_.isNull(materialLine.material) || _.isNull(materialLine.material.id) || materialLine.material.id === '')
        });

        attributes.materials = _.map(attributes.materials, function (materialSpec) {
            return {
                id: materialSpec.id ?? null,
                material: {
                    id: materialSpec.material.id,
                },
                company_id: materialSpec.company_id ?? null,
                coverage: materialSpec.coverage,
                price_per_uom: materialSpec.price_per_uom,
                price_per_item: materialSpec.price_per_item
            }
        });

        attributes.labour = _.filter(attributes.labour, function (labourLine) {
            return ! (_.isNull(labourLine.rate) || _.isNull(labourLine.rate.value) || labourLine.rate.value === '')
        });

        attributes.labour = _.map(attributes.labour, function (labour) {
            return {
                id: labour.id ?? null,
                rate: {
                    id: labour.rate.id,
                },
                coverage_per_hour: labour.coverage_per_hour,
                price_per_uom: labour.price_per_uom,
                price_per_hour: labour.price_per_hour,
            }
        });

        return attributes
    }

    setAttributes(attributes) {
        super.setAttributes(attributes);
        let tokens = [
            attributes.title,
            attributes.nbs,
            attributes.description
        ]
        this.tokens = tokens.join('|').toLowerCase();
    }

    static async all (params = {}) {
        const config = { params }
        const { data } = await Http.get(route('api.v1.global-specs.index'), config)
        return this.make(data)
    }

    static async create (attributes) {
        const url = route('api.v1.global-specs.store')
        const { data } = await Http.post(url, this.parseAttributes(attributes))
        return this.make(data)
    }

    async copyAsLocalSpec (estimate) {
        const url = route('api.v1.estimate-specs.create')
        const payload = { global_spec_id: this.id, estimate_id: estimate.id }
        const { data } = await Http.post(url, payload)
        return this.constructor.make(data)
    }

    async update (attributes = {}) {
        const url = route('api.v1.global-specs.update', this.id)
        const payload = this.constructor.parseAttributes({ ...this.getFormAttributes(), ...attributes })
        const { data } = await Http.put(url, payload)
        return this.fill(data)
    }

    async duplicate () {
        const url = route('api.v1.global-specs.duplicate', this.id)
        const { data } = await Http.put(url)
        return this.constructor.make(data)
    }

    async delete () {
        await Http.delete(route('api.v1.global-specs.destroy', this.id))
    }

    async approve () {
        const { data } = await Http.put(route('api.v1.global-specs.approve', this.id))
        return this.fill(data)
    }

    async unapprove () {
        const { data } = await Http.put(route('api.v1.global-specs.unapprove', this.id))
        return this.fill(data)
    }

    async copyToGlobalSpec () {
        const { data } = await Http.put(route('api.v1.global-specs.copy-to-global', this.id))
        return this.constructor.make(data)
    }

    /** This method is static because it is used on Form objects. */
    static recalculateTotals (spec) {
        const totalMaterialRate = _.sumBy(spec.materials, x => x.price_per_uom)
        const totalLabourRate = _.sumBy(spec.labour, x => x.price_per_uom)
        spec.materials_cost_per_uom = _.round(totalMaterialRate, 2)
        spec.labour_cost_per_uom = _.round(totalLabourRate, 2)
        spec.cost_per_uom = _.round(totalMaterialRate + totalLabourRate, 2)
    }
}
